import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Preloader } from "./components/Preloader";
import DunePage from "./pages/DunePage";
import ErthHome from "./pages/ErthHome";
import JournalPage from "./pages/JournalPage";
import ArticlePage from "./pages/ArticlePage";
import { BRAND } from "./properties";
import { loadState } from "./loadState";

const SmoothScroll = () => {
  const { pathname, hash } = useLocation();
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    const instance = new Lenis({ duration: 1.15, smoothWheel: true });
    setLenis(instance);
    let raf;
    const loop = (time) => {
      instance.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (!id || id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        instance.scrollTo(el, { offset: -70 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      instance.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  useEffect(() => {
    if (!lenis) return undefined;
    if (hash) {
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) lenis.scrollTo(el, { offset: -70 });
      }, 120);
      return () => clearTimeout(t);
    }
    lenis.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash, lenis]);

  return null;
};

function App() {
  const [loading, setLoading] = useState(true);
  const isDune = window.location.pathname.startsWith("/dune");

  useEffect(() => {
    const t = setTimeout(() => {
      setLoading(false);
      loadState.done = true;
    }, 1600);
    return () => clearTimeout(t);
  }, []);

  return (
    <BrowserRouter>
      <SmoothScroll />
      <AnimatePresence>
        {loading && (
          <Preloader
            logo={isDune ? "/images/dune-villas-white.png" : BRAND.logoWhite}
            caption={isDune ? "Area 83" : "escapes across India"}
            logoClass={isDune ? "w-56 sm:w-72" : "w-28 sm:w-36"}
            bg={isDune ? "bg-brand-licorice" : "bg-erth-black"}
          />
        )}
      </AnimatePresence>
      <Routes>
        <Route path="/" element={<ErthHome />} />
        <Route path="/dune-villas" element={<DunePage />} />
        <Route path="/journal" element={<JournalPage />} />
        <Route path="/journal/:slug" element={<ArticlePage />} />
        <Route path="*" element={<ErthHome />} />
      </Routes>
      <Toaster position="top-center" toastOptions={{ style: { borderRadius: 0 } }} />
    </BrowserRouter>
  );
}

export default App;
